import { Component, Input } from '@angular/core';
import { CustomFeeModel, OrderCreateModel, OrderModel, OrderProductCreateModel } from '../../../../../shared/service-proxies/event-service-proxy';

@Component({
    selector: 'app-payment-confirmation-order-card',
    templateUrl: './payment-confirmation-order-card.component.html',
    styleUrl: './payment-confirmation-order-card.component.scss',
    standalone: false
})
export class PaymentConfirmationOrderCardComponent {
  @Input() order: OrderCreateModel = new OrderCreateModel();
  @Input() getTotalPrice!: (product: OrderProductCreateModel) => number;
  @Input() getOrderTotal!: () => number;
  @Input() requireShipping: boolean = false;
  @Input() customFee: CustomFeeModel = new CustomFeeModel();

}
